import React, { Component } from 'react';
import { connect } from 'react-redux';

// utils
import {
  Translations,
  checkJson,
  getNumberLengthFromString,
  isEmptyObject,
  loadIfStateAvailableInSessionStorage,
  savePageStateInSessionStorage
} from '../../../../utils';

//action Creator
import {
  resetAchCreditActiveTabIndex,
  resetCurrentDropDownSelect,
  resetCurrentProductAch,
  setAchCreditActiveTabIndex,
  setAddresses,
  setCaptureProductAch,
  setCurrentDropDownSelect,
  setOtherAccountAch,
  setPersons
} from '../../actions/actionCreator';

// restClient
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../../../restClient';

import CaseDetailAccordion, { NavListAccordionWrapper } from '../../../common/CaseDetailAccordion/caseDetailAccordion';

import { blockUi, unBlockUi } from '../../../../actions/actionCreator';
import { accordionFieldsMap, dropDownDataSourceMap, getCountryAccordions, objectToStringFieldMap, paymentTypeNarrativeMap } from './mappingFile';

//styles
import './styles.css';

class CaptureProductAchCredit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        basicDetails: {
          paymentTypes: [],
          achAccounts: [],
          bacsDCA: [],
          bacsCRAcc: []
        },
        availableAccounts: [],
        availableAddresses: [],
        availableContacts: [],
        availableEchannels: [],
        availableReportDeliveryMethods: [],
        availableDeliveryMethods: [],
        availableEchannelTypes: [],
        availableReportFormat: [],
        availableEftOutputFiles: [],
        availablePriviledges: [],
        availableFreqOfSubmission: [],
        availableLimitPeriods: [],
        otherAccounts: [],
        creditTransferReports: {
          reportFormats: [],
          reportNames: []
        },
        creditTransferSpecific: {
          bureauDetails: [],
          softwareSupplierDirect: [],
          echannels: [],
          authorizedAccounts: [],
          reversalAccount: [],
          submissionMethods: [],
          paymentCodeDes: [],
          bureauOnYourBehalfReports: []
        },
        mandateServiceUserTraining: {
          primaryAndAditionalUserTraining: [],
          otherUserTraining: []
        },
        primaryAndAdditionalContact: {
          primaryContactDetails: [],
          additionalContactDetails: []
        },
        addressAndContacts: {},
        softwareSupplierDirect: [],
        useAddressForDelivery: ''
      },
      pageJson: {},
      status: {},
      disabledOptions: { availableAccounts: [], availableAddresses: [], availableContacts: [], availableEchannels: [], otherUserTrainingavailableContacts: [] },
      selectedCountry: '',
      selectedPaymentType: undefined,
      applicableAccordions: [],
      checkboxTaxonomy: {}
    };
    this.deleteKeysFromStateArr = [];
    this.dropDownDataSourceMap = dropDownDataSourceMap;
  }

  loadPageState = () => {
    this.props.blockUi();
    var { productId, caseId } = this.props.match.params;

    aemHostClient("/aemData/formData/json_ach-credit-all-closed")
      .then(({ data }) => {
        this.setState({ pageJson: data }, () => {

          this.getCountryTaxanomy();
          this.setTranslatedDataFromTaxonomy();
          taxonomyHostClient(Translations(this.state.pageJson.par.aemform_basicDetails.accountTaxonomy, this.props.lang.currentLang.lang, this.props.lang.translatedData))
            .then(({ data }) => {
              this.setState({ accountCountries: data.responseData.countryTaxonomy.classificationNodes })

              eapiClient("/product/ach-credit/" + productId)
                .then(({ data }) => {
                  this.updateFormData(data);
                  this.props.unBlockUi();
                });
            });

          taxonomyHostClient(Translations(this.state.pageJson.par.aemform_addressAndContacts.countryTaxonomy, this.props.lang.currentLang.lang, this.props.lang.translatedData))
            .then(({ data }) => {
              this.setState({ countryTaxonomy: data.responseData.classificationNodes })
              let { productId, caseId } = this.props.match.params;

              eapiClient("/product/caseRelatedEchannel/case/" + caseId)
                .then(({ data }) => {
                  this.setState({
                    formData: {
                      ...this.state.formData,
                      availableEchannels: data.responseData
                    }
                  })
                  this.getTaxanomyEchannel();

                  return eapiClient("/addresses/case/" + caseId)
                }).then(({ data }) => {
                  this.setState({
                    formData: {
                      ...this.state.formData,
                      availableAddresses: data.responseData
                    }
                  });
                  this.props.setAddresses(data.responseData);
                  this.getTaxanomyAddress();
                });
            });

          let formDataObject = {};
          for (let [accordionKey, accordionContent] of Object.entries(this.state.pageJson.par)) {
            if (accordionKey.startsWith('aemform_')) {
              formDataObject[accordionContent.name] = {}
            }
          }
        });
      })
  }

  updateFormData = (data) => {
    var { productId, caseId } = this.props.match.params;

    this.setState({
      formData: {
        ...this.state.formData,
        ...data.responseData,
        basicDetails: {
          ...this.state.formData.basicDetails,
          ...data.responseData.basicDetails
        },
        addressAndContacts: {
          ...this.state.formData.addressAndContacts,
          ...data.responseData.addressAndContacts
        },
        creditTransferReports: {
          ...this.state.formData.creditTransferReports,
          ...data.responseData.creditTransferReports
        }
      },
      selectedCountry: data.responseData.country.value.split(':')[data.responseData.country.value.split(':').length - 2].split('-').join('').toLowerCase(),
      selectedPaymentType: this.getPaymentType(data.responseData.paymentType || undefined),
      applicableAccordions: getCountryAccordions((data.responseData.country.value.split(':')[data.responseData.country.value.split(':').length - 2].split('-').join('').toLowerCase()) + (this.getPaymentType(data.responseData.paymentType || undefined) ? `_${this.getPaymentType(data.responseData.paymentType || undefined)}` : '')),
    }, () => {

      this.transformDataObjToStr(this.state.formData, true);
    });
    this.props.setCaptureProductAch(this.state);
    this.fetchAvailableAccountsList(productId);

  }

  fetchAvailableAccountsList = (productId) => {
    if (this.props.currentProductAch.country) {
      // var _currencydata = this.state.checkboxTaxonomy.others.filter(item =>{
      //   if(item.lid === this.state.formData.country.value){
      //     return item.id;
      //   }
      // })


      eapiClient("/product/ach-credit/" + productId + "/countries/" + this.props.currentProductAch.country.value + "/currency/" + "test" + "/accounts")
        .then(({ data }) => {
          this.setState({
            formData: {
              ...this.state.formData,
              availableAccounts: data.responseData
            }
          });
          this.props.setOtherAccountAch(data.responseData);
          this.getTaxanomyAccount();
        });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.currentProductAch.otherAccounts !== undefined && nextProps.currentProductAch.availableAccounts !== undefined) {
      if (this.props.currentProductAch.otherAccounts.length !== nextProps.currentProductAch.availableAccounts.length) {
        this.setState({
          formData: {
            ...this.state.formData,
            availableAccounts: nextProps.currentProductAch.availableAccounts
          }
        });
      }
    }
    if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {

      taxonomyHostClient(Translations(this.state.pageJson.par.aemform_basicDetails.achTaxonomy, nextProps.lang.currentLang.lang, nextProps.lang.translatedData))
        .then(({ data }) => {
          this.setState({ countryList: data.responseData.classificationNodes })
        });
      eapiClient(Translations(this.state.pageJson.par.aemform_creditTransferSpecific.creditTaxonomy, this.props.lang.currentLang.lang, this.props.lang.translatedData))
        .then(({ data }) => {
          this.setState({
            checkboxTaxonomy: data.responseData
          }, () => {
            this.setDropDownDataFromTaxonomy(['reportDeliveryMethod', 'deliveryMethod', 'echannelType',
              'reportFormat', 'eftoutputFile', 'primaryDirectPriviledges',
              'primaryIndirectPriviledges', 'additionalDirectPriviledges',
              'additionalIndirectPriviledges', 'frequencyOfSubmission', 'limitPeriod']);

          })
        });
      taxonomyHostClient(Translations(this.state.pageJson.par.aemform_basicDetails.accountTaxonomy, nextProps.lang.currentLang.lang, nextProps.lang.translatedData))
        .then(({ data }) => {
          this.setState({ accountCountries: data.responseData.countryTaxonomy.classificationNodes })
          this.getTaxanomyAccount();
        });

      taxonomyHostClient(Translations(this.state.pageJson.par.aemform_addressAndContacts.countryTaxonomy, nextProps.lang.currentLang.lang, nextProps.lang.translatedData))
        .then(({ data }) => {
          this.setState({ countryTaxonomy: data.responseData.classificationNodes })
          this.getTaxanomyEchannel();
          this.getTaxanomyAddress();
        });

    }
  }

  componentWillMount() {
    let { productId, caseId } = this.props.match.params;
    loadIfStateAvailableInSessionStorage(this, null, () => {
      this.loadPageState();
    });



    eapiClient("/product/ach-credit/" + productId + "/status")
      .then(({ data }) => {
        this.setState({ status: data.responseData }, () => { });
      });

    //this.getCountryTaxanomy();
    //this.getTaxanomyAccount();
    //this.getTaxanomyEchannel();
    //this.getTaxanomyAddress();
    //this.setTranslatedDataFromTaxonomy();
  }

  getTaxanomyAccount = () => {
    let availableAccounts = this.state.formData.availableAccounts;
    if (availableAccounts !== undefined) {
      if (this.state.accountCountries !== undefined) {
        availableAccounts = availableAccounts.map(item => {
          this.state.accountCountries.filter(countItem => {
            if ('country' in item) {
              if (countItem.id === item.country.value) {
                item.country.name = countItem.name
              }
            }
            return countItem;
          });
          this.setState({
            formData: {
              ...this.state.formData,
              availableAccounts: availableAccounts
            }
          })
          this.props.setOtherAccountAch(availableAccounts);
        });
      }
    }
  }

  getTaxanomyAddress = () => {
    let availableAddresses = this.state.formData.availableAddresses;
    if (availableAddresses !== undefined) {
      if (this.state.countryTaxonomy !== undefined) {
        availableAddresses = availableAddresses.map(item => {
          this.state.countryTaxonomy.filter(countItem => {
            if ('country' in item) {
              if (countItem.id === item.country.value) {
                item.country.name = countItem.name
              }
            }
            return countItem;
          });
          this.setState({
            formData: {
              ...this.state.formData,
              availableAddresses: availableAddresses
            }
          })
          this.props.setAddresses(availableAddresses);
        });
      }
    }
  }

  getTaxanomyEchannel = () => {
    let availableEchannels = this.state.formData.availableEchannels;
    if (this.state.countryTaxonomy !== undefined) {
      if (availableEchannels !== undefined) {
        availableEchannels = availableEchannels.map(item => {
          this.state.countryTaxonomy.filter(countItem => {
            if ('country' in item) {
              if (countItem.id === item.country.value) {
                item.country.name = countItem.name
              }
            }
            return countItem;
          });
          this.setState({
            formData: {
              ...this.state.formData,
              availableEchannels: availableEchannels
            }
          })
        });
      }
    }
  }

  setTranslatedDataFromTaxonomy = () => {
    eapiClient(Translations(this.state.pageJson.par.aemform_creditTransferSpecific.creditTaxonomy, this.props.lang.currentLang.lang, this.props.lang.translatedData))
      .then(({ data }) => {
        this.setState({
          checkboxTaxonomy: data.responseData
        }, () => {
          this.setDropDownDataFromTaxonomy(['reportDeliveryMethod', 'deliveryMethod', 'echannelType',
            'reportFormat', 'eftoutputFile', 'primaryDirectPriviledges',
            'primaryIndirectPriviledges', 'additionalDirectPriviledges',
            'additionalIndirectPriviledges', 'frequencyOfSubmission', 'limitPeriod']);

        })
      });
  }

  componentDidMount() {

    let { productId, caseId } = this.props.match.params;

    eapiClient("/persons/case/" + caseId)
      .then(({ data }) => {
        let currentContactsData = []
        let formData = {
          ...this.state.formData,
          availableContacts: data.responseData,
        }
        const currentDropDownObject = checkJson(window.sessionStorage.getItem("getCurrentDropDown") || this.props.currentDropDown) || {};
        const { orderChain, accordionName } = currentDropDownObject
        const orderChainOption = typeof orderChain === "string" && orderChain.split("_")

        if (data.responseData) {
          let updatedPersons = data.responseData
          const selectedPrimaryContactsOption = Array.isArray(this.props.persons) && Array.isArray(updatedPersons) &&
            updatedPersons.find(updatedPerson => this.props.persons.find(person => updatedPerson.id === person.id && person.isUpdated === true)) || {}

          const { telephoneNumber, emailAddress } = selectedPrimaryContactsOption
          currentContactsData = this.state.formData[accordionName] && Array.isArray(this.state.formData[accordionName][orderChainOption[0]]) ? [...this.state.formData[accordionName][orderChainOption[0]]] : []

          if (telephoneNumber) {
            if (Array.isArray(currentContactsData) && currentContactsData.length) {
              currentContactsData[orderChainOption[2] || "0"] = { ...currentContactsData[orderChainOption[2] || "0"], workTelephoneNumber: telephoneNumber, }
            }
          }
          // DGT-7482 - removed unused session storage modification
          // else {
          //   if (Array.isArray(currentContactsData) && currentContactsData.length) {
          //     const contactObject = currentContactsData[orderChainOption[2] || "0"]
          //     contactObject.workTelephoneNumber = ''
          //   }
          // }
          if (emailAddress) {
            if (Array.isArray(currentContactsData) && currentContactsData.length) {
              currentContactsData[orderChainOption[2] || "0"] = { ...currentContactsData[orderChainOption[2] || "0"], workEmailAddress: emailAddress }
            }
          }
          // DGT-7482 - removed unused session storage modification
          // else {
          //   if (Array.isArray(currentContactsData) && currentContactsData.length) {
          //     const contactObject = currentContactsData[orderChainOption[2] || "0"]
          //     contactObject.workEmailAddress = ''
          //   }
          // }

        }
        if (Array.isArray(currentContactsData) && currentContactsData.length) {
          const contactType = orderChainOption[0]
          formData = {
            ...formData, primaryAndAdditionalContact: { ...formData.primaryAndAdditionalContact, [contactType]: currentContactsData }
          }
        }

        this.setState({
          formData: formData
        });
        this.props.setPersons(data.responseData);
      });

    eapiClient("/product/caseRelatedEchannel/case/" + caseId)
      .then(({ data }) => {
        this.setState({
          formData: {
            ...this.state.formData,
            availableEchannels: data.responseData
          }
        })
        this.getTaxanomyEchannel();
      });

    eapiClient("/addresses/case/" + caseId)
      .then(({ data }) => {
        this.setState({
          formData: {
            ...this.state.formData,
            availableAddresses: data.responseData
          }
        });
        this.props.setAddresses(data.responseData);
        this.getTaxanomyAddress();
      })

    eapiClient("/product/ach-credit/" + productId)
      .then(({ data }) => {
        this.fetchAvailableAccountsList(productId);
      });

    let getCurrentDropDown = window.sessionStorage.getItem("getCurrentDropDown");
    let getCurrentDropDownName, getCurrentDropDownIndex, _currentValue, _dataSourceKey, _disbaledOptionKey, _currentParent, _subMethNum, _subAccounts, _orderChain;
    let getCurrentDropDownValue = window.sessionStorage.getItem('key' + getCurrentDropDown);
    let _getCurrentDropDown = checkJson(getCurrentDropDown);
    if (getCurrentDropDown !== null) {
      if (isNaN(parseInt(_getCurrentDropDown.dropDownName.substring(_getCurrentDropDown.dropDownName.length - 1)))) {
        getCurrentDropDownName = _getCurrentDropDown.dropDownName;
      } else {
        //The function getNumberLengthFromString gets length of number appended at last with the given string, e.g achAccountsId11 -> returns 2
        let _indexLength = getNumberLengthFromString(_getCurrentDropDown.dropDownName);
        getCurrentDropDownName = _getCurrentDropDown.dropDownName.substring(0, _getCurrentDropDown.dropDownName.length - _indexLength);
        getCurrentDropDownIndex = _getCurrentDropDown.dropDownName.substring(_getCurrentDropDown.dropDownName.length - _indexLength);
      }
      _dataSourceKey = _getCurrentDropDown.dataSourceKey;
      _disbaledOptionKey = _getCurrentDropDown.disbaledOptionKey;
      _currentParent = _getCurrentDropDown.accordionName
      _orderChain = _getCurrentDropDown.orderChain
    }

    if ((_currentParent === 'basicDetails' || _currentParent === 'creditTransferSpecific' || _currentParent === 'primaryAndAdditionalContact' || _currentParent === 'mandateServiceUserTraining') && getCurrentDropDownValue !== null) {
      switch (getCurrentDropDownName) {
        case 'serviceChargeAcc':
          _currentValue = this.state.formData[_currentParent][getCurrentDropDownName];
          this.setState({
            formData: {
              ...this.state.formData,
              [_currentParent]: {
                ...this.state.formData[_currentParent],
                [getCurrentDropDownName]: getCurrentDropDownValue
              }
            }
          });
          break;

        case 'achAccountsId':
        case 'bacsCRAccId':
        case 'bacsDCAId':
        case 'securityId':
        case 'trainingContact':
          let _accounts, currAggBoxName;
          if (_currentParent === 'basicDetails') {
            if (getCurrentDropDownName === 'achAccountsId') {
              currAggBoxName = 'achAccounts';
            } else if (getCurrentDropDownName === 'bacsCRAccId') {
              currAggBoxName = 'bacsCRAcc';
            } else if (getCurrentDropDownName === 'bacsDCAId') {
              currAggBoxName = 'bacsDCA';
            }
            _accounts = [...this.state.formData[_currentParent][currAggBoxName]] || undefined;
          } else {
            if (_currentParent === 'creditTransferSpecific' && this.state.selectedCountry && this.state.selectedCountry === 'canada') {
              currAggBoxName = 'authorizedAccounts';
              _accounts = [...this.state.formData[_currentParent][currAggBoxName]] || undefined;
            }
            if (_currentParent === 'creditTransferSpecific' && this.state.selectedCountry && this.state.selectedCountry === 'hongkong') {
              currAggBoxName = 'reversalAccount';
              _accounts = [...this.state.formData[_currentParent][currAggBoxName]] || undefined;
            }
            // if(_currentParent === 'creditTransferSpecific' && this.state.selectedCountry && this.state.selectedCountry === 'china'){
            //   currAggBoxName = 'submissionAccounts';
            //   let _index =  _orderChain.split('_')[0]
            //    _index = _index[_index.length-1];
            //   _accounts = [...this.state.formData[_currentParent]['submissionMethods'][_index][currAggBoxName]] || undefined;
            // }
            if (_currentParent === 'primaryAndAdditionalContact') {
              currAggBoxName = _orderChain.split('_')[0];
              _accounts = [...this.state.formData[_currentParent][currAggBoxName]]
            }
            if (_currentParent === 'mandateServiceUserTraining') {
              currAggBoxName = _orderChain.split('_')[0];
              _accounts = [...this.state.formData[_currentParent][currAggBoxName]]
            }
          }

          if (_accounts !== undefined) {
            _dataSourceKey = _getCurrentDropDown.dataSourceKey;
            _disbaledOptionKey = _getCurrentDropDown.disbaledOptionKey;
            _currentValue = _accounts.length ? _accounts[getCurrentDropDownIndex][getCurrentDropDownName] : undefined;
            _accounts[_accounts.length ? getCurrentDropDownIndex : 0] = {
              ..._accounts[_accounts.length ? getCurrentDropDownIndex : 0],
              [getCurrentDropDownName]: getCurrentDropDownValue
            };

            this.setState({
              formData: {
                ...this.state.formData,
                [_currentParent]: {
                  ...this.state.formData[_currentParent],
                  [currAggBoxName]: _accounts
                }
              }
            });

          }

          if (_getCurrentDropDown.paymentType === 'submissionMethodA' || _getCurrentDropDown.paymentType === 'submissionMethodB') {
            for (let s = 0; s < this.state.formData[_currentParent]['submissionMethods'].length; s++) {
              let subMth = this.state.formData[_currentParent]['submissionMethods'][s].submissionMethod.value.split(':');
              if (subMth[subMth.length - 2] === _getCurrentDropDown.paymentType) {
                _subMethNum = [...this.state.formData[_currentParent]['submissionMethods']];
                _subAccounts = [...this.state.formData[_currentParent]['submissionMethods'][s]['submissionAccounts']] || undefined
                let _currentObjValue = _subAccounts.length === 0 ? undefined : _subAccounts[getCurrentDropDownIndex];
                _currentValue = _subAccounts.length === 0 ? undefined : _subAccounts[getCurrentDropDownIndex].achAccountsId;
                _subMethNum[s].submissionAccounts[_subAccounts.length === 0 ? 0 : getCurrentDropDownIndex] = {
                  ..._currentObjValue,
                  ['achAccountsId']: getCurrentDropDownValue
                }
              }
            }
            this.setState({
              formData: {
                ...this.state.formData,
                [_currentParent]: {
                  ...this.state.formData[_currentParent],
                  submissionMethods: _subMethNum
                }
              }
            });
          }
          break;

        default:
      }
      if ((getCurrentDropDownName === 'primaryDebitAccId' || getCurrentDropDownName === 'additionalDebitAccountId' || getCurrentDropDownName === 'empPhoneNum' || getCurrentDropDownName === 'addressId' || getCurrentDropDownName === 'smsContactId' || getCurrentDropDownName === 'contactId' || getCurrentDropDownName === 'emailAddId') && getCurrentDropDownValue !== null) {
        for (let p = 0; p < this.state.formData.basicDetails['paymentTypes'].length; p++) {
          let payType = this.state.formData.basicDetails['paymentTypes'][p].paymentType.value.split(':');
          if (payType[payType.length - 2] === _getCurrentDropDown.paymentType) {
            let _setPayments = [...this.state.formData.basicDetails['paymentTypes']]
            if (getCurrentDropDownName === 'emailAddId') {
              _currentValue = _setPayments[p]['emailContactId'].length ? _setPayments[p]['emailContactId'][getCurrentDropDownIndex].emailAddId : undefined;
              _setPayments[p]['emailContactId'][getCurrentDropDownIndex !== undefined ? getCurrentDropDownIndex : 0] = { emailAddId: getCurrentDropDownValue };

            } else {
              _currentValue = _setPayments[p][getCurrentDropDownName];
              _setPayments[p][getCurrentDropDownName] = getCurrentDropDownValue;
            }

            this.setState({
              formData: {
                ...this.state.formData,
                basicDetails: {
                  ...this.state.formData.basicDetails,
                  paymentTypes: _setPayments
                }
              }
            });
          }
        }
      }
    } else if (_currentParent === 'addressAndContacts' || _currentParent === 'creditTransferReports' && getCurrentDropDownValue !== null) {
      switch (getCurrentDropDownName) {
        case 'addressId':
          _currentValue = this.state.formData[_currentParent].addressId
          break;
        case 'contactId':
          _currentValue = this.state.formData[_currentParent].contactId
          break;
        case 'echannelId':
          _currentValue = this.state.formData[_currentParent].echannelId
          break;
      }
      this.setState({
        formData: {
          ...this.state.formData,
          [_currentParent]: {
            ...this.state.formData[_currentParent],
            [getCurrentDropDownName]: getCurrentDropDownValue
          }
        }
      });
    }
    let updatedDisableObj = {
      currentValue: _currentValue,
      updateValue: getCurrentDropDownValue,
      dataSourceKey: _dataSourceKey,
      disbaledOptionKey: _disbaledOptionKey
    };
    this.updateDisabledArray(updatedDisableObj);
    window.sessionStorage.removeItem("getCurrentDropDown");
    window.sessionStorage.removeItem('key' + getCurrentDropDown);
  }

  saveStateToSessionOnEdit = () => {
    savePageStateInSessionStorage(this.state, this.props.history.location.pathname);
  }

  componentWillUnmount() {
    this.setState({
      formData: {}
    })
  }

  getPaymentType = (paymentObject) => {
    if (paymentObject) {
      let _splitId = paymentObject.value.split(':');
      return _splitId[_splitId.length - 2].toLowerCase();
    } else {
      return undefined;
    }
  }

  setDropDownDataFromTaxonomy = (actionTypes = []) => {
    let setData = [], taxonomyData = this.state.checkboxTaxonomy.classificationNodes;
    let setDataObj = {
      availablePriviledges: []
    };
    for (let acType = 0; acType < actionTypes.length; acType++) {
      for (let node of taxonomyData) {
        let splitNode = node.id.split(':');
        if (splitNode[splitNode.length - 2] === actionTypes[acType]) {
          setData = node.associations ? node.associations.map(method => { return { id: method.id, name: method.name } }) : [];

          switch (actionTypes[acType]) {
            case 'reportDeliveryMethod':
              setDataObj.availableReportDeliveryMethods = setData;
              break;
            case 'deliveryMethod':
              setDataObj.availableDeliveryMethods = setData;
              break;
            case 'echannelType':
              setDataObj.availableEchannelTypes = setData;
              break;
            case 'reportFormat':
              let _setData = setData.filter(item => { return item.id.split(':')[10] !== 'txt' && item.id.split(':')[10] !== 'xls' })
              setDataObj.availableReportFormat = _setData;
              break;
            case 'eftoutputFile':
              setDataObj.availableEftOutputFiles = setData;
              break;
            case 'primaryDirectPriviledges':
            case 'primaryIndirectPriviledges':
            case 'additionalDirectPriviledges':
            case 'additionalIndirectPriviledges':
              let _privlegObject = { id: node.id, name: node.name, associations: setData }
              setDataObj.availablePriviledges.push({ [actionTypes[acType]]: _privlegObject });
              break;
            case 'frequencyOfSubmission':
              setDataObj.availableFreqOfSubmission = setData;
              break;
            case 'limitPeriod':
              setDataObj.availableLimitPeriods = setData;
              break;
            default:
              console.log('Unknown action type to set taxonomy data for drop down');
          }
          this.setState({
            formData: {
              ...this.state.formData,
              ...setDataObj
            }
          });
        }
      }
    }
  }

  handleChange = (accordionKey) => e => {
    let changedAccordionData = { ...e };
    let newFormData = { ...this.state.formData, [accordionKey]: changedAccordionData };
    this.setState({
      formData: newFormData
    });
  }

  updateDisabledArray = (e) => {
    let currentDisabledOptions = { ...this.state.disabledOptions };
    if (e.type === 'removeAggregateForm') {
      let mapRemovalEntries = [], methodLabel;
      let nameArray = e.name.split('-');
      let tempAggregateFormData = { ...this.state.formData[e.accordionName] };
      for (let itemName of nameArray) {
        tempAggregateFormData = tempAggregateFormData[itemName];
      }
      if (nameArray[0] === 'submissionMethods') {
        let tempSubMethodobj = { ...this.state.formData[e.accordionName].submissionMethods[nameArray[nameArray.length - 2]] }
        let currMethod = tempSubMethodobj.submissionMethod.value.split(':');
        if (currMethod[currMethod.length - 2] === "submissionMethodA") {
          methodLabel = 'A';
        } else if (currMethod[currMethod.length - 2] === "submissionMethodB") {
          methodLabel = 'B';
        }
      }
      let processedData = tempAggregateFormData.map((item, i) => {
        if (i != e.idx) {
          return item;
        } else {
          for (let [k, v] of Object.entries(item)) {
            if (this.dropDownDataSourceMap.has(k)) {
              let pushEntry;
              if (nameArray[0] === 'submissionMethods') {
                pushEntry = nameArray[nameArray.length - 1] + methodLabel;
              } else {
                pushEntry = nameArray[nameArray.length - 1];
              }
              pushEntry += this.dropDownDataSourceMap.get(k) + '_' + v
              mapRemovalEntries.push(pushEntry);
            }
          }
        }
      });
      let filteredData = processedData.filter(item => item);
      let currentDisabledOptions = { ...this.state.disabledOptions };
      if (mapRemovalEntries.length > 0) {
        for (let sourceKey of mapRemovalEntries) {
          currentDisabledOptions[sourceKey.split('_')[0]] = currentDisabledOptions[sourceKey.split('_')[0]].filter(item => item != sourceKey.split('_')[1]);
        }
      }
      let accordionAggregateFormData = { ...this.state.formData[e.accordionName] };
      let accordionAggregatePointer = accordionAggregateFormData;
      for (let iName = 0; iName < nameArray.length - 1; iName++) {
        accordionAggregatePointer = accordionAggregatePointer[nameArray[iName]];
      }
      accordionAggregatePointer[nameArray[nameArray.length - 1]] = [...filteredData];
      let replaceFormData = { ...this.state.formData, [e.accordionName]: accordionAggregateFormData };
      this.setState({
        formData: replaceFormData,
        disabledOptions: currentDisabledOptions
      })
    } else {
      if (!e.removeItems && e.type !== 'emptyListOperation') {
        if (currentDisabledOptions[e.disbaledOptionKey]) {
          let replaceIdx = currentDisabledOptions[e.disbaledOptionKey].indexOf(e.currentValue);
          if (replaceIdx === -1) {
            currentDisabledOptions[e.disbaledOptionKey].push(e.updateValue);
          } else {
            //Either replace disabledOptions with other value or remove a value from disabledoptions array
            if (e.updateValue && e.updateValue.trim() !== "") {
              currentDisabledOptions[e.disbaledOptionKey][replaceIdx] = e.updateValue;
            } else {
              //To remove entries from disabledOptions array updateValue should be 'undefined' -> e.g. unchecking checkbox having dropdowns
              if (!e.updateValue) {
                let tempDisabledOptions = [...currentDisabledOptions[e.disbaledOptionKey]];
                currentDisabledOptions[e.disbaledOptionKey] = tempDisabledOptions.filter(item => item !== e.currentValue);
              }
            }
          }
        } else {
          currentDisabledOptions = { ...currentDisabledOptions, [e.disbaledOptionKey]: [e.updateValue] };
        }
      } else {
        //single or bulk removal of items from disabledOptions object, i.e. from different sources
        if (e.removeItems) {
          let removeItemsArray = e.removeItems;
          for (let rm of removeItemsArray) {
            currentDisabledOptions[rm.disbaledOptionKey] = currentDisabledOptions[rm.disbaledOptionKey].filter(item => item !== rm.currentValue);
          }
        } else if (e.type === 'emptyListOperation') {
          let _disableKeyName = e.disableKey;
          if (currentDisabledOptions[_disableKeyName]) {
            delete currentDisabledOptions[_disableKeyName]
          };
        }
      }
      this.setState({
        disabledOptions: currentDisabledOptions
      });
    }
  }

  getRelevantFields = (accordionName, fieldsArray = []) => {
    let retArr = [];
    let deleteKeysFromStateArr = [];
    for (let field of fieldsArray) {
      if (typeof field === 'string') {
        retArr.push(field);
      } else if (typeof field === 'object') {
        for (let [k, v] of field.entries()) {
          if (k === 'static_text' || k === "static_text_heading" || k === "static_text_note") {
            retArr.push(new Map([[k, v]]));
          } else {
            retArr.push(k);
            console.log('k.split', k, k.split('_')[1]);

            switch (k.split('_')[1]) {
              case 'wps':
              case 'spo':
              case 'nonWps':
              case 'so':
              case 'sp':
              case 'salary':
                // console.log('now pushing for key =>'+k);
                if (this.state.formData[accordionName]['paymentTypes'] && this.state.formData[accordionName]['paymentTypes'].length > 0) {
                  for (let i = 0; i < this.state.formData[accordionName]['paymentTypes'].length; i++) {
                    let payType = this.state.formData[accordionName]['paymentTypes'][i]['paymentType']['value'].split(':');
                    if (payType[payType.length - 2] === k.split('_')[1]) {
                      retArr.push(new Map([[k, v]]));
                    }
                  }
                }

                break;

              case 'isReportingRequired':
              case 'designateContact':
                let isRpt = this.state.formData[accordionName][k.split('_')[1]];
                if (isRpt) {
                  retArr.push(...this.getRelevantFields(accordionName, v));
                } else {
                  if (k.split('_')[1] === 'designateContact') {
                    if (!this.state.formData[accordionName][k.split('_')[1]] && this.state.formData[accordionName]['contactId'] && this.state.formData[accordionName]['contactId'].trim() !== "") {
                      //code for removing disbaled selected contact id in 'contactid' dropdown
                      // let _removeObject = {
                      //                     disbaledOptionKey : 'contactIdavailableContacts',
                      //                     currentValue: this.state.formData[accordionName]['contactId'],
                      //                     updateValue: undefined
                      //                     };
                      // this.updateDisabledArray(_removeObject);
                      deleteKeysFromStateArr.push(`${accordionName}-contactId`);
                    }
                  }
                }

                // console.log('now pushing for key =>'+k);

                break;

              case 'eChannel':
              case 'other':
                let _parentArrayName = k.split(':')[0];
                if (_parentArrayName === 'reportFormats' || _parentArrayName === 'primaryAndAditionalUserTraining') {
                  if (this.state.formData[accordionName][_parentArrayName] && this.state.formData[accordionName][_parentArrayName].length > 0) {
                    for (let rptItem of this.state.formData[accordionName][_parentArrayName]) {
                      let splittedRptValue = rptItem.value.split(':');
                      if (splittedRptValue[splittedRptValue.length - 2] === k.split('_')[1]) {
                        retArr.push(new Map([[k, v]]));
                      }
                    }
                  }
                } else {
                  console.log('Unknown parent for other checkbox');
                }

                // console.log('now pushing for key =>'+k);

                break;

              case 'electronicReportFormats':
                if (this.state.formData[accordionName]['electronicReportFormats']) {
                  let rptFormat = this.state.formData[accordionName]['electronicReportFormats'].value.split(':');
                  if (rptFormat[rptFormat.length - 2] === "full" || rptFormat[rptFormat.length - 2] === "summary") {
                    let mapKey = "electronicReportFormats:" + rptFormat[rptFormat.length - 2];
                    let electronicReportFmtArray = v[0].get(mapKey);
                    if (rptFormat[rptFormat.length - 2] === "summary") {
                      if (this.state.formData[accordionName]['reportToByOrderedBy']) {
                        deleteKeysFromStateArr.push(`${accordionName}-reportToByOrderedBy`);
                      }
                    }
                    retArr.push(...this.getRelevantFields(accordionName, electronicReportFmtArray));
                  }
                  else {
                    console.log('Unknown value provided for electronicReportFormats');
                  }
                }
                break;

              case 'autoPayElectonic':
              case 'autoPayCredit':
              case 'autoPayStatistics':
                if (this.state.formData[accordionName]['reportNames'] && this.state.formData[accordionName]['reportNames'].length > 0) {
                  for (let rptItem of this.state.formData[accordionName]['reportNames']) {
                    let splittedRptValue = rptItem.reportName.value.split(':');
                    if (splittedRptValue[splittedRptValue.length - 2] === k.split('_')[1]) {
                      retArr.push(...this.getRelevantFields(accordionName, v));
                      break;
                    }
                  }
                }

                break;
              case 'reportDeliveryMethod':
                if (this.state.formData[accordionName]['reportDeliveryMethod']) {
                  let splittedRptDelvrMethod = this.state.formData[accordionName]['reportDeliveryMethod'].value.split(':');
                  if (splittedRptDelvrMethod[splittedRptDelvrMethod.length - 2] === 'other') {
                    retArr.push(...this.getRelevantFields(accordionName, v));
                  } else {
                    if (this.state.formData[accordionName]['otherReportDeliveryMethod']) {
                      deleteKeysFromStateArr.push(`${accordionName}-otherReportDeliveryMethod`)
                    }
                  }
                }
                break;

              case 'eChannelType':
                if (this.state.formData[accordionName]['eChannelType']) {
                  let echType = this.state.formData[accordionName]['eChannelType'].value.split(':');
                  switch (echType[echType.length - 2]) {
                    case 'hsbcNetId':
                      if (this.state.formData[accordionName]['hsbcConnectId']) {
                        deleteKeysFromStateArr.push(`${accordionName}-hsbcConnectId`)
                      }
                      if (this.state.formData[accordionName]['otherEchannelId']) {
                        deleteKeysFromStateArr.push(`${accordionName}-otherEchannelId`)
                      }

                      retArr.push(...this.getRelevantFields(accordionName, ['guidetextbox_hsbcNetId']));
                      break;
                    case 'hsbcConnectId':
                      if (this.state.formData[accordionName]['hsbcNetId']) {
                        deleteKeysFromStateArr.push(`${accordionName}-hsbcNetId`)
                      }
                      if (this.state.formData[accordionName]['otherEchannelId']) {
                        deleteKeysFromStateArr.push(`${accordionName}-otherEchannelId`)
                      }

                      retArr.push(...this.getRelevantFields(accordionName, ['guidetextbox_hsbcConnectId']));
                      break;
                    case 'otherEchannelId':
                      if (this.state.formData[accordionName]['hsbcConnectId']) {
                        deleteKeysFromStateArr.push(`${accordionName}-hsbcConnectId`)
                      }
                      if (this.state.formData[accordionName]['hsbcNetId']) {
                        deleteKeysFromStateArr.push(`${accordionName}-hsbcNetId`)
                      }

                      retArr.push(...this.getRelevantFields(accordionName, ['guidetextbox_otherEchannelId']));
                      break;
                    default:
                      console.log('Unknown echannel type', echType);
                  }
                }
                break;

              case 'submissionMethodA':
              case 'submissionMethodB':
                if (this.state.formData[accordionName]['submissionMethods'] && this.state.formData[accordionName]['submissionMethods'].length > 0) {
                  for (let i = 0; i < this.state.formData[accordionName]['submissionMethods'].length; i++) {
                    let splittedSubMed = this.state.formData[accordionName]['submissionMethods'][i].submissionMethod.value.split(':');
                    if (splittedSubMed[splittedSubMed.length - 2] === k.split('_')[1]) {
                      retArr.push(new Map([[k, v]]));
                      break;
                    }
                  }
                }
                break;
              case 'transactionCode':
                let tranCode = this.state.formData[accordionName]['transactionCode'] || undefined;
                if (tranCode && Object.keys(tranCode).length > 1) {
                  let splittedTranValue = tranCode.value.split(':');
                  if (splittedTranValue[splittedTranValue.length - 2] === 'other') {
                    // retArr.push(new Map([ [k,v] ]));
                    retArr.push(...this.getRelevantFields(accordionName, v));
                  } else {
                    if (this.state.formData[accordionName]['transactionCodeOther']) {
                      deleteKeysFromStateArr.push(`${accordionName}-transactionCodeOther`)
                    }
                  }
                }
                break;
              case 'frequencyOfSubmission':
                let freq = this.state.formData[accordionName]['frequencyOfSubmission'] || undefined;
                if (freq && Object.keys(freq).length > 1) {
                  let splittedTranValue = freq.value.split(':');
                  if (splittedTranValue[splittedTranValue.length - 2] === 'other') {
                    // retArr.push(new Map([ [k,v] ]));
                    retArr.push(...this.getRelevantFields(accordionName, v));
                  } else {
                    if (this.state.formData[accordionName]['otherFrequency']) {
                      deleteKeysFromStateArr.push(`${accordionName}-otherFrequency`)
                    }
                  }
                }
                break;
              case 'addacs':
              case 'all':
              case 'arucs':
              case 'arudd':
              case 'auddis':
              case 'awacs':
              case 'liveInputReport':
              case 'msgTestReport':
              case 'testInputReport':
                let _parentArrayReport = k.split(':')[0];
                if (_parentArrayReport === 'bureauOnYourBehalfReports') {
                  if (this.state.formData[accordionName][_parentArrayReport] && this.state.formData[accordionName][_parentArrayReport].length > 0) {
                    for (let rptItem of this.state.formData[accordionName][_parentArrayReport]) {
                      let splittedRptValue = rptItem.value.split(':');
                      if (splittedRptValue[splittedRptValue.length - 2] === k.split('_')[1]) {
                        retArr.push(new Map([[k, v]]));
                      }
                    }
                  }
                } else {
                  console.log('Unknown parent for other checkbox');
                }
                break;
              case 'bureauOnYourBehalf':
                let isBehalf = this.state.formData[accordionName][k.split('_')[1]];
                if (isBehalf) {
                  retArr.push(...this.getRelevantFields(accordionName, v));
                }
                break;
              default:
                console.log('Unknown component in AccordionFieldMap: ', k)
            }

          }
        }
      }
    }
    // this.conditionalKeyRemovalFromState(deleteKeysFromStateArr);
    this.deleteKeysFromStateArr.push(...deleteKeysFromStateArr);
    return retArr;
  }

  conditionalKeyRemovalFromState = () => {
    let tempoData = { ...this.state.formData };
    for (let delItem of this.deleteKeysFromStateArr) {
      let delKeysArr = delItem.split('-');
      let formDataPointer = tempoData;
      for (let fp = 0; fp < delKeysArr.length - 1; fp++) {
        formDataPointer = formDataPointer[delKeysArr[fp]]
      }
      if (formDataPointer && formDataPointer[delKeysArr[delKeysArr.length - 1]]) {
        if (delKeysArr[delKeysArr.length - 1] === 'contactId') {
          // code for removing disbaled selected contact id in 'contactid' dropdown
          let _removeObject = {
            disbaledOptionKey: 'contactIdavailableContacts',
            currentValue: formDataPointer[delKeysArr[delKeysArr.length - 1]],
            updateValue: undefined
          };
          this.updateDisabledArray(_removeObject);
          delete formDataPointer[delKeysArr[delKeysArr.length - 1]];
        } else {
          delete formDataPointer[delKeysArr[delKeysArr.length - 1]];
        }
      }
    }
    this.deleteKeysFromStateArr = [];
    this.setState({
      formData: tempoData
    }, () => { this.deleteKeysFromStateArr = [] });
  }


  passRelevantFields = (accordionName) => {
    let relevantFields = [];
    let tempFormData = this.state.formData;
    let countryName = this.state.selectedCountry;
    if (countryName === "unitedkingdomhsbcbankplc") {
      countryName = "unitedkingdomhsbcuk";
    }
    let _accordionKey = countryName + '_' + accordionName + `${this.state.selectedPaymentType ? '_' + this.state.selectedPaymentType : ''}`;
    if (accordionFieldsMap.has(_accordionKey)) {
      let accordionFieldsArray = accordionFieldsMap.get(_accordionKey);
      relevantFields.push(...this.getRelevantFields(accordionName, accordionFieldsArray));
    };
    return relevantFields;
  }

  //'checkForEmptyObject' checks the payload (before submitting) for empty
  //objects and arrays within outer array and objects.
  // e.g [{}] -> [], {key:[{}]} -> {key:[]}
  checkForEmptyObject = (obj) => {
    if (typeof obj === 'object') {
      for (let key in obj) {
        let curItem = obj[key];
        if (typeof curItem === 'object') {
          if (curItem instanceof Array) {
            if (curItem.length > 0) {
              curItem = curItem.filter(item => {
                if (typeof item === 'object') {
                  if (item instanceof Array && item.length > 0) {
                    return item;
                  } else if (Object.keys(item).length > 0) {
                    item = this.checkForEmptyObject(curItem);
                    return item;
                  }
                }
              });
            }
          } else {
            curItem = this.checkForEmptyObject(curItem);
          }
        }
        obj[key] = curItem;
      }
    }
    return obj;
  }

  getCountryTaxanomy = () => {
    taxonomyHostClient(Translations(this.state.pageJson.par.aemform_basicDetails.achTaxonomy, this.props.lang.currentLang.lang, this.props.lang.translatedData))
      .then(({ data }) => {
        this.setState({ countryList: data.responseData.classificationNodes })
      });
  }

  getTranslatedAccounts = (currentProductAch) => {
    if (this.state.countryList !== undefined) {
      if (currentProductAch !== undefined) {
        this.state.countryList.filter(countItem => {
          if ('country' in currentProductAch) {
            if (countItem.id === currentProductAch.country.value) {
              currentProductAch.country.name = countItem.name
              if (currentProductAch.paymentType !== undefined) {
                countItem.associations.filter(paymentType => {
                  if (paymentType.id === currentProductAch.paymentType.value) {
                    currentProductAch.paymentType.name = paymentType.name
                  }
                })
              }
            }
          }
          return currentProductAch;
        });
        return currentProductAch;
      }
    }
  }

  //accordion form data
  submitTabdata = (payLoad) => {
    if (!isEmptyObject(payLoad) && payLoad.creditTransferSpecific && (Array.isArray(payLoad.creditTransferSpecific.bureauDetails) && payLoad.creditTransferSpecific.bureauDetails.length) && (Array.isArray(payLoad.creditTransferSpecific.bureauOnYourBehalfReports) && payLoad.creditTransferSpecific.bureauOnYourBehalfReports.length === 0)) {
      delete payLoad.creditTransferSpecific.bureauOnYourBehalfReports
    }
    let sanitizedformData = this.checkForEmptyObject(payLoad);
    let transformedData = this.transformDataObjToStr(sanitizedformData);
    // let transformedData = sanitizedformData;
    let { productId } = this.props.match.params;
    let finalPayload = {};
    transformedData.id = productId;
    transformedData.productType = "ach-credit";
    finalPayload.product = transformedData
    eapiClient("/product/ach-credit/" + productId, {
      method: 'PUT',
      data: JSON.stringify(finalPayload)
    })
      .then(({ data }) => {
        this.updateFormData(data);
        eapiClient("/product/ach-credit/" + productId + "/status")
          .then(({ data }) => {
            this.setState({ status: data.responseData }, () => { console.log(">>>", this.state.status) });
          });
        if (this.state.formData.primaryAndAdditionalContact.primaryContactDetails.find(primaryContact => this.state.formData.availableContacts.find(contact => contact.id !== primaryContact.securityId))) {
          const { caseId } = this.props.match.params;

          eapiClient("/persons/case/" + caseId)
            .then(({ data }) => {
              this.setState({
                formData: {
                  ...this.state.formData,
                  availableContacts: data.responseData
                }
              });
              this.props.setPersons(data.responseData);
            });
        }
      })
  }

  //save and Return payLoad

  submitFormData = () => {
    let Payload = new SaveAndReturnPayload();
    Payload.setPayLoad(this.state.formData);
    let { productId } = this.props.match.params;
    let finalPayload = {};

    //let Payload = {...this.state.formData}
    let sanitizedformData = this.checkForEmptyObject(Payload.data);
    sanitizedformData = this.transformDataObjToStr(sanitizedformData);
    sanitizedformData.productType = "ach-credit";
    finalPayload.product = sanitizedformData;
    eapiClient("/product/ach-credit/" + productId, {
      method: 'PUT',
      data: JSON.stringify(finalPayload)
    })
      .then(({ data }) => {
        this.props.resetCurrentProductAch();
        this.props.history.push('/case-body');
      });
  }

  // set accordion index

  getTabIndex = (index) => {
    if (!(index === this.props.displayTabIndex))
      this.props.setAchCreditActiveTabIndex(index);
  }

  transformDataObjToStr = (frmData, reverseConversion = false) => {
    for (let key of Object.keys(frmData)) {
      if (objectToStringFieldMap.has(key)) {
        for (let [k, v] of Object.entries(objectToStringFieldMap.get(key))) {
          for (let vItem of v) {
            let splitChain = vItem.split('-');
            let idxOfArrayComp = splitChain.indexOf(k);
            let ptrToFrmData = frmData;
            for (let ic = 0; ic < splitChain.length; ic++) {
              if (ptrToFrmData === undefined) { break; }
              if (ic === idxOfArrayComp && (ptrToFrmData instanceof Array === false)) {
                if (typeof ptrToFrmData === 'object') {
                  if (ptrToFrmData[splitChain[ic]] && ptrToFrmData[splitChain[ic]] instanceof Array) {
                    if (reverseConversion) {
                      ptrToFrmData[splitChain[ic]] = ptrToFrmData[splitChain[ic]].map(convItem => { return { [splitChain[splitChain.length - 1]]: convItem } });
                    } else {
                      ptrToFrmData[splitChain[ic]] = ptrToFrmData[splitChain[ic]].map(convItem => { return convItem[splitChain[ic + 1]] }).filter(item => item && item.trim() !== "");
                    }

                  }
                }
              } else {
                if (ptrToFrmData instanceof Array) {
                  for (let arrItem of ptrToFrmData) {
                    if (ic === idxOfArrayComp) {

                      for (let [arrItemKey, arrItemValue] of Object.entries(arrItem)) {

                        if (arrItemKey === splitChain[ic] && arrItem[arrItemKey] instanceof Array) {

                          if (reverseConversion) {
                            arrItem[arrItemKey] = arrItem[splitChain[ic]].map(convItem => { return { [splitChain[splitChain.length - 1]]: convItem } });
                          } else {
                            arrItem[arrItemKey] = arrItem[splitChain[ic]].map(convItem => { return convItem[splitChain[ic + 1]] }).filter(item => item && item.trim() !== "");
                          }
                        }
                      }
                    }
                  }
                } else if (ptrToFrmData instanceof Object && (ptrToFrmData instanceof Array === false)) {
                  ptrToFrmData = ptrToFrmData[splitChain[ic]];
                } else {
                  break;
                }
              }
            }
          }
        }
      }
    };
    return frmData;
  }

  renderAccordians = () => {
    // console.log('STATE LOGGED ISSSSSS: ',this.state);
    let accordionIndex = 1;
    let accordionsArray = []; //formJSON object needs to be converted into array for rendering accordions
    let returnAccordionsArray = [];
    for (let [key, value] of Object.entries(this.state.pageJson.par)) {
      if ((key.startsWith('aemform_') && this.state.applicableAccordions.includes(value.name)) || key.startsWith('guidebutton_')) {
        accordionsArray.push({ ['accordionIndex']: accordionIndex, ['accordionName']: key, ['accordionContent']: value });
        accordionIndex += 1;
      }
    }

    returnAccordionsArray = accordionsArray.map((accordionItem, acrdnIdx) => {
      let _formDataAccordionKey = accordionItem.accordionContent.name;

      if (accordionItem.accordionName.startsWith('aemform_')) {
        let relevantAccordionFields = this.passRelevantFields(_formDataAccordionKey);
        return (
          <CaseDetailAccordion
            key={'accordionItem' + accordionItem.accordionIndex}
            name={_formDataAccordionKey}
            lang={this.props.lang.currentLang.lang}
            navAccHeading={`${accordionItem.accordionIndex}. ${accordionItem.accordionContent.title ? Translations(accordionItem.accordionContent.title, this.props.lang.currentLang.lang, this.props.lang.translatedData) || 'Form Details' : 'Form Details'}`}
            status={this.state.status[_formDataAccordionKey] !== undefined ? this.state.status[_formDataAccordionKey].status : ''}
            _onClickAccordionHeader={this.getTabIndex.bind(this, accordionItem.accordionIndex - 1)}
            accordionFields={accordionItem.accordionContent}
            formData={this.state.formData[_formDataAccordionKey] || {}}
            paymentNarrativeMap={paymentTypeNarrativeMap}
            stateData={this.state}
            history={this.props.history}
            dropDownData={{
              'availableAccounts': this.state.formData['availableAccounts'],
              'availableAddresses': this.state.formData['availableAddresses'],
              'availableContacts': this.state.formData['availableContacts'],
              'availableEchannels': this.state.formData['availableEchannels'],
              'availableReportDeliveryMethods': this.state.formData['availableReportDeliveryMethods'],
              'availableDeliveryMethods': this.state.formData['availableDeliveryMethods'],
              'availableEchannelTypes': this.state.formData['availableEchannelTypes'],
              'availableReportFormat': this.state.formData['availableReportFormat'],
              'availableEftOutputFiles': this.state.formData['availableEftOutputFiles'],
              'availableFreqOfSubmission': this.state.formData['availableFreqOfSubmission'],
              'availableLimitPeriods': this.state.formData['availableLimitPeriods']
            } || {}}
            dropDownDataDisabled={this.state.disabledOptions}

            updateDisabledOptionArray={this.updateDisabledArray}

            _dropDownDataSourceMap={this.dropDownDataSourceMap}

            groupCheckBoxData={{ 'availablePriviledges': this.state.formData['availablePriviledges'] } || {}}

            _accordionName={accordionItem.accordionContent.name}
            lang={this.props.lang.currentLang.lang}
            translatedData={this.props.lang.translatedData}
            onChange={this.handleChange(_formDataAccordionKey)}
            relevantFields={relevantAccordionFields}
            _saveStateToSessionOnEdit={this.saveStateToSessionOnEdit}
            _submitTabdata={this.submitTabdata}
            _checkboxTaxonomy={this.state.checkboxTaxonomy}
            _selectedPaymentType={this.state.selectedPaymentType}
            currentDropDown={this.props.currentDropDown}
            setCurrentDropDownSelect={this.props.setCurrentDropDownSelect}
            resetCurrentDropDownSelect={this.props.resetCurrentDropDownSelect}
            updateFormData={(data) => { this.setState({ formData: { ...this.state.formData, data } }) }}
          />
        )
      } else if (accordionItem.accordionName.startsWith('guidebutton_')) {
        return (
          <div key={'accordionItem' + accordionItem.accordionIndex} className="form-buttons-section">
            <div className="form-buttons-wrapper">
              <button className={accordionItem.accordionContent.bsClass} onClick={this.submitFormData}>
                {Translations(accordionItem.accordionContent.text, this.props.lang.currentLang.lang, this.props.lang.translatedData) || `Save Changes`}
              </button>
            </div>
          </div>
        )
      }
    });

    //Logic to remove (unwanted) keys from payload which are dependent on radiobutton and dropdown selection
    if (this.deleteKeysFromStateArr.length > 0) {
      this.conditionalKeyRemovalFromState();
    };

    return returnAccordionsArray;

  }

  render() {
    document.title = (this.state.pageJson.par !== undefined && Object.keys(this.state.checkboxTaxonomy).length > 0)
      ? `${"Product Requests"} - ${"Review Product"} - ${this.props.currentProductAch.country && this.state.countryList !== undefined ? this.getTranslatedAccounts(this.props.currentProductAch).country.name : ''}${this.props.currentProductAch.paymentType ? `, ${this.getTranslatedAccounts(this.props.currentProductAch).paymentType.name}` : ''} - ${'HSBC GLCM'}` : `${"Product Requests"}- ${'HSBC GLCM'}`;
    return ((this.state.pageJson.par !== undefined && Object.keys(this.state.checkboxTaxonomy).length > 0) ?
      (<div className="product-ach-container">
        <div className="pannel-heading-container">
          <h2 className="pannel-heading">{`${this.props.currentProductAch.country && this.state.countryList !== undefined ? this.getTranslatedAccounts(this.props.currentProductAch).country.name : ''}${this.props.currentProductAch.paymentType ? `, ${this.getTranslatedAccounts(this.props.currentProductAch).paymentType.name}` : ''}`}</h2>
          <p className="pannel-sub-heading">{this.props.currentProductAch.country ? this.props.currentProductAch.achAgent.name : ''}</p>
          <p className="optional-text">{Translations(this.state.pageJson.par.aemform_basicDetails.description, this.props.lang.currentLang.lang, this.props.lang.translatedData)}</p>
        </div>
        <div className="gdocs-clear-float">

        </div>
        <NavListAccordionWrapper open={this.props.displayTabIndex}>
          {this.state.selectedCountry && this.state.selectedCountry.trim() !== '' ? this.renderAccordians() : ''}
        </NavListAccordionWrapper>
      </div>)
      : '')
  }
}

class SaveAndReturnPayload {
  constructor() {
    this.data = {};
  }
  setPayLoad({ basicDetails, addressAndContacts, creditTransferReports, creditTransferSpecific, primaryAndAdditionalContact, mandateServiceUserTraining, id }) {
    this.data.basicDetails = basicDetails;
    this.data.addressAndContacts = addressAndContacts;
    this.data.creditTransferReports = creditTransferReports;
    this.data.creditTransferSpecific = creditTransferSpecific;
    this.data.primaryAndAdditionalContact = primaryAndAdditionalContact;
    this.data.mandateServiceUserTraining = mandateServiceUserTraining;
    this.data.id = id;
  }
}

const mapStateToProps = state => ({
  lang: state.lang,
  cases: state.cases,
  currentProductAch: state.currentProductAch.data.formData,
  displayTabIndex: state.currentProductAch.activeTabIndex,
  persons: state.persons,
  currentDropDown: state.currentProductAch.currentDropDown
});

const mapDispatchToProps = dispatch => {
  return {
    setCaptureProductAch: data => {
      dispatch(setCaptureProductAch(data));
    },
    setOtherAccountAch: accounts => {
      dispatch(setOtherAccountAch(accounts))
    },
    setAddresses: addresses => {
      dispatch(setAddresses(addresses));
    },
    resetCurrentProductAch: () => {
      dispatch(resetCurrentProductAch());
    },
    setPersons: persons => {
      dispatch(setPersons(persons));
    },
    setAchCreditActiveTabIndex: index => {
      dispatch(setAchCreditActiveTabIndex(index))
    },
    resetAchCreditActiveTabIndex: () => {
      dispatch(resetAchCreditActiveTabIndex())
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    },
    setCurrentDropDownSelect: data => {
      dispatch(setCurrentDropDownSelect(data))
    },
    resetCurrentDropDownSelect: data => {
      dispatch(resetCurrentDropDownSelect(data))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CaptureProductAchCredit);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductAchCredit/index.js